import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { MenuItems } from 'src/app/shared/interfaces/menu-items';
import { TemplateService } from 'src/app/shared/services/template.service';
import { canAccessAdminPath, isAdminPortalRole } from 'src/app/shared/constants/admin-access.constants';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnChanges {
  @Input() companyNotifs: any[] = [];

  notifsNumber: number = 0;
  pendingOrdersCount: number = 0;

  items: MenuItems[] = [
    {
      link: '/my-dashboard',
      label: 'Dashboard',
      icon: 'bi-layout-text-window-reverse',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/my-services',
      label: 'Services',
      icon: 'bi-columns-gap',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/my-providers',
      label: 'Providers',
      icon: 'bi-people',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    /*{
      link: '/my-shop',
      label: 'My Shop',
      icon: 'bi-cart3',
      roles: ['company'],
      value: 0,
      showValue: false,
    },*/
    {
      link: '/orders',
      label: 'My Orders',
      icon: 'bi-list-ol',
      roles: ['company'],
      value: 0,
      showValue: true,
    },
    {
      link: '/business-hours',
      label: 'Business Hours',
      icon: 'bi-clock-history',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/reports',
      label: 'Earnings & Analytics',
      icon: 'bi-bar-chart-fill',
      roles: ['company'],
      value: 0,
      showValue: false,
    },

    {
      link: '/dashboard',
      label: 'Dashboard',
      icon: 'bi-layout-text-window-reverse',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/withdrawal-requests',
      label: 'Withdrawals Requests',
      icon: 'bi-cash-stack',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    /*{
      link: '/dynamic-services',
      label: 'Dynamic Services',
      icon: 'bi-columns-gap',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },*/
    {
      link: '/dynamic-services',
      label: 'Dynamic Services',
      icon: 'bi-columns-gap',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/approvals',
      label: 'New Users Approvals',
      icon: 'bi-person-check',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/users',
      label: 'Users',
      icon: 'bi-person',
      roles: ['admin', 'superAdmin', 'assistant', 'manager', 'support'],
      value: 0,
      showValue: false,
    },
    {
      link: '/deletion-requests',
      label: 'Deletion Requests',
      icon: 'bi-person-x',
      roles: ['admin', 'superAdmin', 'assistant', 'manager', 'support'],
      value: 0,
      showValue: false,
    },
    // TEMPORARY — remove after QA (see pages/admin/qa-test-panel/REMOVE.md)
    {
      link: '/qa-test-panel',
      label: 'QA Test Panel (temp)',
      icon: 'bi-clipboard-check',
      roles: [
        'admin',
        'superAdmin',
        'assistant',
        'manager',
        'support',
        'accountant',
      ],
      value: 0,
      showValue: false,
    },
    {
      link: '/admin/orders',
      label: 'Orders',
      icon: 'bi-list-ol',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/employees',
      label: 'Employees',
      icon: 'bi-people',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/cars',
      label: 'Car Brans & Models',
      icon: 'bi-car-front-fill',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/shop-management',
      label: 'Shop Management',
      icon: 'bi-cart3',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },

    {
      link: '/analytics',
      label: 'Reports & Analytics',
      icon: 'bi-bar-chart-fill',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/admin/payments',
      label: 'Online Transactions',
      icon: 'bi-credit-card-2-front',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/offers-ads',
      label: 'Offers & Ads',
      icon: 'bi-card-heading',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/admin-offers',
      label: 'MoCI Offers Review',
      icon: 'bi-shield-check',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/app-control',
      label: 'App Control',
      icon: 'bi-sliders',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/my-ads',
      label: 'Ads Manager',
      icon: 'bi-card-heading',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/notifications',
      label: 'Notifications',
      icon: 'bi-bell',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/greetings',
      label: 'Greetings occasions',
      icon: 'bi-chat-heart',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    /*{
      link: '/feedbacks',
      label: 'Feedbacks',
      icon: 'bi-lightbulb',
      roles: ['admin', 'superAdmin', 'assistant'],
    },*/
    {
      link: '/nojoom',
      label: 'Nojoum',
      icon: 'bi-trophy',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    {
      link: '/bakat',
      label: 'Bakat',
      icon: 'bi-list-stars',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
    /*{
      link: '/admin/help-center',
      label: 'Help Center',
      icon: 'bi-headset',
      roles: ['admin', 'superAdmin', 'assistant'],
    },
    {
      link: '/admin/profile',
      label: 'My Profile',
      icon: 'bi-person',
      roles: ['admin', 'superAdmin', 'assistant'],
    },
    {
      link: '/admin/settings',
      label: 'Account Settings',
      icon: 'bi-gear',
      roles: ['admin', 'superAdmin', 'assistant'],
    },*/
    {
      link: '/legals',
      label: 'Legals',
      icon: 'bi-newspaper',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
    },
  ];

  bottomCompanyMenu: MenuItems[] = [
    {
      link: '/docs',
      label: 'Documentation',
      icon: 'bi-book-half',
      roles: ['company'],
      value: 0,
      showValue: false,
      externalUrl: 'https://app.doc-tree.com/docs/e8dde0d1-5b40-43b5-9de0-4da2b26f94a4',
    },
    {
      link: '/help-center',
      label: '',
      icon: 'bi-headset',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/faqs',
      label: '',
      icon: 'bi-question-circle-fill',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
  ];

  bottomAdminMenu: MenuItems[] = [
    {
      link: '/admin/docs',
      label: 'Documentation',
      icon: 'bi-book-half',
      roles: ['admin', 'superAdmin', 'assistant'],
      value: 0,
      showValue: false,
      externalUrl: 'https://app.doc-tree.com/docs/644f0604-c943-4618-a981-5240d9c7ced1',
    },
    {
      link: '/admin/help-center',
      label: '',
      icon: 'bi-headset',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
    {
      link: '/feedbacks',
      label: '',
      icon: 'bi-lightbulb',
      roles: ['company'],
      value: 0,
      showValue: false,
    },
  ];

  currentUser: any;

  constructor(
    private afAuth: AngularFireAuth,
    public templateService: TemplateService,
    private afs: AngularFirestore,
    private router: Router,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['companyNotifs']) {
      this.notifsNumber = this.companyNotifs.length;
    }
  }

  ngOnInit() {
    this.getCurrentUser();
    this.notifsNumber = this.companyNotifs.length;
    this.getPendingOrdersCount();
  }

  getPendingOrdersCount() {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.afs
          .collection('ServiceRequests', (ref) =>
            ref
              .where('companyId', '==', user.uid)
              .where('status', '==', 'pending')
          )
          .valueChanges()
          .subscribe((orders: any[]) => {
            this.pendingOrdersCount = orders.length;
            const ordersItem = this.items.find((item) => item.link === '/orders');
            if (ordersItem) {
              ordersItem.value = this.pendingOrdersCount;
            }
          });
      }
    });
  }

  getCurrentUser() {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.afs
          .collection('users')
          .doc(user.uid)
          .valueChanges()
          .subscribe((data: any) => {
            if (!data?.role) {
              return;
            }
            if (this.currentUser?.role === data.role) {
              return;
            }
            this.currentUser = data;
          });
      }
    });
  }

  collapseSidebar() {
    this.templateService.collapsed = !this.templateService.collapsed;
    this.templateService.setMessage('Collapse Sidebar');
  }

  get visibleItems(): MenuItems[] {
    return this.items.filter((item) => this.showMenuItem(item));
  }

  trackByLink(_index: number, item: MenuItems): string {
    return item.link;
  }

  isActive(link: string): boolean {
    return this.router.isActive(link, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  go(link: string, event: MouseEvent): void {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    void this.router.navigateByUrl(link);
  }

  showMenuItem(item: MenuItems): boolean {
    const role = this.currentUser?.role;
    if (!role) {
      return false;
    }

    if (item.roles.includes('company')) {
      return role === 'company';
    }

    if (item.roles.includes(role)) {
      return true;
    }

    return canAccessAdminPath(role, item.link);
  }

  showAdminBottomBar(): boolean {
    return isAdminPortalRole(this.currentUser?.role);
  }
}
